<div class="login_bg">
        <!-- Form Section Start -->
        <div class="inner_container"> 
        <div class="login_form_wrapper">
            <div class="login_form_bg"><a href="login" class="logo" title="ManpowerGroup logo"></a></div>
            <div class="login_form">
                <div class="login_header_right">
                    <h1>{{'DIRECTTEXT' | translate}}</h1>
                    <div class="dropdown language_dropdown">
                        <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton2" data-bs-toggle="dropdown" aria-expanded="false">
                            {{buttonText}}
                        </button>
                        <ul class="dropdown-menu dropdown-menu" aria-labelledby="dropdownMenuButton2">
                            <li><a class="dropdown-item {{isSelected == 'en'? 'active':''}}" href="javascript:void(0)" (click)="switchLanguage('en')">English</a></li>
                            <li><a class="dropdown-item {{isSelected == 'jp'? 'active':''}}" href="javascript:void(0)" (click)="switchLanguage('jp')">Japanese</a></li>
                        </ul>
                    </div>
                </div>

                <!-- メンテナンス停止中メッセージ -->
                <div *ngIf="isSuspended && !adminBypassMode" class="maintenance_message">
                    <p class="maintenance_text" *ngIf="isSelected == 'jp'">
                        ただいまメンテナンスのため<br />システムを停止しています。
                    </p>
                    <p class="maintenance_text" *ngIf="isSelected != 'jp'">
                        The system is currently down for maintenance.
                    </p>
                    <p class="maintenance_period">
                        <span *ngIf="isSelected == 'jp'">停止期間：</span>
                        <span *ngIf="isSelected != 'jp'">Downtime period: </span>
                        {{suspendStartDate}} ～ {{suspendEndDate}}
                    </p>
                </div>

                <!-- 通常ログインフォーム（停止中/バイパス以外） -->
                <form *ngIf="!isSuspended || adminBypassMode" [formGroup]="loginForm">
                    <div class="mb-4">
                        <label for="userName" class="form-label">{{'USERIDLEBEL' | translate}}</label>
                        <div class="input-group login_id">
                            <input type="email" class="form-control" id="loginID" formControlName="loginID"
                            name="loginID"
                            required aria-describedby="login_id"
                            autocomplete="username"
                            placeholder="{{'USERID' | translate}}"
                            (keydown.enter)="login()">
                            <span><i class="bi bi-person"></i></span>
                            <small *ngIf="loginForm.controls['loginID'].dirty && loginForm.hasError('required','loginID')" class="text-danger mt-1">{{'NEEDUSERID' | translate}}</small>
                        </div>
                    </div>
                    <div class="mb-4">
                        <label for="password" class="form-label">{{'PASSWORDLEBEL' | translate}}</label>
                        <div class="input-group login_id">
                            <input [type]="type" class="form-control" id="password" formControlName="password" name="password"
                            aria-describedby="login_password"
                            autocomplete="current-password"
                            placeholder="{{'PASSWORD' | translate}}"
                            (keydown.enter)="login()">
                            <span class="eye-slash"><i class="bi" [ngClass]="eyeIcon" (click)="hideShowPass()"></i></span>
                            <small *ngIf="loginForm.controls['password'].dirty && loginForm.hasError('required','password')" class="text-danger mt-1">{{'NEEDPASSWORD' | translate}}</small>
                        </div>
                    </div>
                    <div class="row align-items-center">
                        <div class="col"><button type="button" class="btn btn-primary login" (click)="login()">{{'LOGINTEXT' | translate}}</button></div>
                        <div *ngIf="!isTestPeriod" class="col text-end">
                            <a href="javascript:void(0)" class="forgot_password" (click)="goToForgotPassword()">
                                {{'FORGOTPASSWORD' | translate}}?
                            </a>
                        </div>
                    </div>
                </form>
                <!-- Login form End-->

            </div>
        </div>
        </div>
        <!-- Form Section End -->

        <!-- Content Section Start -->
        <div class="inner_container">
        <div class="login_content_wrapper">
            <ul class="login_content_section">
                <!-- 告知テキスト（Valid=1 かつ NoticeStartDate～NoticeEndDate の範囲内、複数あれば順に表示） -->
                <ng-container *ngFor="let notice of notices">
                    <li>
                        <section>
                            <div class="notice_html_content" [innerHTML]="notice.noticeText" (click)="onNoticeClick($event)"></div>
                            <p *ngIf="notice.noticeStartDate" class="notice_start_date">{{ notice.noticeStartDate | date:'yyyy-MM-dd' }}</p>
                        </section>
                    </li>
                </ng-container>
            </ul>
        </div>
        </div>
        <!-- Content Section End -->

    </div>
